import { render, staticRenderFns } from "./MONGASTON.vue?vue&type=template&id=65e38d9c&"
import script from "./MONGASTON.vue?vue&type=script&lang=js&"
export * from "./MONGASTON.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports